import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../core';
import Icon from '../Icon';
import LinkButton from '../LinkButton';
import Text from '../Text';

const DicomHintContainer = styled.div`
  border: 1px solid #16223f;
  border-radius: 4px;
  border-bottom: 5px solid;
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  margin-top: 16px;
  text-align: start;
  ul {
    margin: 10px;
    list-style: disc;
  }
  p {
    margin: 0;
  }
`;

const StyledHintText = styled(Text)`
  display: flex;
  svg {
    margin: 3px 16px 0 0;
  }
`;

const StyledLinkButton = styled(LinkButton)`
  min-width: 0;
`;

// this is necessary for gatsby to build using the window object
const isBrowser = typeof window !== 'undefined';

const DicomHintAlert = () => (
  <DicomHintContainer>
    <StyledHintText>
      <Icon type="info" color={colors.white} backgroundColor={colors.midnightExpress} size={20} />
      You will need to install and use a DICOM viewer to view these images as they are a specialized
      file type.
    </StyledHintText>
    <ul>
      <li>
        <Text>
          If your computer runs Windows, please use the RadiAnt viewer available at{' '}
          <StyledLinkButton
            onClick={() =>
              isBrowser && window.open(`https://www.radiantviewer.com/`, '_blank', 'noreferrer')
            }
          >
            radiantviewer.com
          </StyledLinkButton>
          .
        </Text>
      </li>
      <li>
        <Text>
          If you have an Apple computer, please use the Horos viewer available at{' '}
          <StyledLinkButton
            onClick={() =>
              isBrowser && window.open(`https://horosproject.org/`, '_blank', 'noreferrer')
            }
          >
            horosproject.org
          </StyledLinkButton>
          .
        </Text>
      </li>
    </ul>
  </DicomHintContainer>
);

export default DicomHintAlert;
